export const loadingAlert = ({isOpen}) => {
    return{
        type: "OPEN-LOADING",
        isOpen : isOpen,
    }
}